import { Injectable } from "@angular/core";
import { ConfigurationService } from "@maximizer/core/shared/data-access";
import { IQBoostViewStore } from "@maximizer/ai/data-access";
import { Observable, tap } from "rxjs";
import { ConfigurationSetting } from "@maximizer/core/shared/domain";
import { isNullOrEmpty } from "@maximizer/shared/util";

@Injectable()
export class IqboostRecentUserPrompts {

  private readonly MAX_RECENT_USER_PROMPTS = 5;

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly store: IQBoostViewStore,
  ) {}

  getRecentUserPrompts(): string[] {
    return this.store.dataProcessingFeatureGroup().user.recentUserPrompts ?? [];
  }

  pushUserPrompt(prompt: string): void {
    if (isNullOrEmpty(prompt?.trim())) {
      return;
    }

    const recentUserPrompts = [
      ...this.getRecentUserPrompts().filter((recentPrompt) => recentPrompt.trim() !== prompt.trim()),
    ];

    recentUserPrompts.unshift(prompt);

    if (recentUserPrompts.length > this.MAX_RECENT_USER_PROMPTS) {
      recentUserPrompts.length = this.MAX_RECENT_USER_PROMPTS;
    }

    this.saveRecentUserPrompts(recentUserPrompts)
      .subscribe();
  }

  private saveRecentUserPrompts(recentUserPrompts?: string[]): Observable<ConfigurationSetting | null> {
    this.store.dataProcessingFeatureGroup().user = {
      ...this.store.dataProcessingFeatureGroup().user,
      recentUserPrompts: recentUserPrompts ?? [],
    };

    return this.configurationService.updateSetting(
      this.store.configurationSettingUser()?.id ?? null,
      this.store.configurationSettingCodesUser(),
      JSON.stringify(this.store.dataProcessingFeatureGroup().user),
    ).pipe(
      tap((setting) => setting && this.store.setConfigurationSettingUser(setting)),
    );
  }
}
